"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _fonts = require("../fonts");
var _Svg = require("../Svg");
var _excluded = ["children", "caret"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowTriangle = function arrowTriangle(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.84375 0L5.84375 5L10.8438 0H0.84375Z",
    fill: "white"
  }));
};
arrowTriangle.defaultProps = {
  width: "11",
  height: "5",
  viewBox: "0 0 11 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Toggle = (0, _styledComponents.default)(function (_ref) {
  var children = _ref.children,
    caret = _ref.caret,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, _extends({
    "data-toggle": "dropdown",
    tag: "span"
  }, props, {
    caret: false
  }), children, (caret === undefined || caret) && /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
    as: arrowTriangle
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  align-items: center;\n  cursor: default;\n  ", " {\n    margin-left: 10px;\n  }\n  ", " {\n    margin-bottom: 0;\n  }\n  & > * {\n    cursor: default !important;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary;
}, _Svg.Svg, _fonts.H5);
exports.Toggle = Toggle;